<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_174')"
    icon="res-suggestsrule"
    :res-name="resName"
    :actions="params.actions"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :res-id="data.id"
      :id="listId"
      :on-manager="onManager"
      :getParams="getParams"
      :hiddenGroupBy="true"
      @side-page-trigger-handle="sidePageTriggerHandle"
      @init-side-page-tab="initSidePageTab"
      @single-refresh="singleRefresh" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'
import Suggestsalert from '@Bill/views/suggestsalert/components/List.vue'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import SuggestsruleDetail from './Detail'

export default {
  name: 'SuggestionruleSidePage',
  components: {
    Actions,
    SuggestsruleDetail,
    Suggestsalert,
  },
  mixins: [WindowsMixin, SidePageMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_185'), key: 'suggestsrule-detail' },
        { label: this.$t('meter.match_resources'), key: 'suggestsalert' },
        { label: this.$t('bill.text_186'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForSuggestsruleSidePage'
        case 'suggestsalert':
          return 'SuggestAlertList'
        default:
          return ''
      }
    },
    resName () {
      return this.detailData.name
    },
    getParams () {
      if (this.params.windowData.currentTab === 'suggestsalert') {
        return {
          suggest_rule_id: this.detailData.id,
        }
      }
      return {}
    },
  },
}
</script>
